import React from "react";

const ApproveModal = ({ show, onClose, onConfirm, message }) => {
  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block">
      <div className="d-flex justify-content-center align-items-center vh-100">

        <div className="modal-container">
          <p className="">{message || "Are you sure?"}</p>

          <div className="modal-actions ">
            <button className="confirm-btn w-25" onClick={onConfirm}>
              Yes
            </button>
            <button className="cancel-btn w-25 " onClick={onClose}>
              No
            </button>
          </div>
        </div>
        </div>

      </div>

      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          .modal-container {
            background: #fff;
            padding: 40px 20px;
            border-radius: 8px;
            width: 400px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            text-align: center;
            margin-bottom:10%;
          }
  body[data-layout-mode="dark"] .modal-container {
            background: #2e2e2e;
  }

            .modal-container p{
            font-size: 19px;
            font-weight:400;
            margin-bottom:15px;
            }
          .modal-actions {
            margin-top: 20px;
            display: flex;
            justify-content: space-around;
          }
          .confirm-btn {
            background: #4caf50;
            color: white;
            padding: 10px 20px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .confirm-btn:hover {
            background: #45a049;
          }
          .cancel-btn {
            background: #f44336;
            color: white;
            padding: 10px 20px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .cancel-btn:hover {
            background: #e53935;
          }
        `}
      </style>
    </>
  );
};

export default ApproveModal;
